import { bind } from 'bind-decorator';
import * as React from 'react';

import { ContainerOne } from 'elements';
import messages from '../../displayMessages';
import { BlockPreview } from './BlockPreview';
import { BlockProps } from './models';
import { createAssetViewedEventForItem } from './utils';
import { Button, Icon } from 'ui/components';

export class DocumentBlock extends React.PureComponent<BlockProps, {}> {

    public render() {
        return (
            <ContainerOne>
                <BlockPreview
                    previewImageUrl={this.props.itemMetadata.imageUrl}
                    button={
                        <>
                            <Icon name='file-pdf-upload' className='icon-section' />
                            <Button
                                btnStyle='primary'
                                label={messages.blockDocumentShowLabel}
                                onClick={this.onShow}
                            />
                        </>
                    }
                />
            </ContainerOne>
        );
    }

    @bind private async onShow() {
        if (this.props.blockData.studentViewData?.document_url) {
            // Show the pdf in a new tab; it's too slow and resource intensive to try to embed a pdfviewer.
            window.open(this.props.blockData.studentViewData.document_url, '_blank', 'noopener,noreferrer');
            createAssetViewedEventForItem(this.props.itemMetadata.id);
        }
    }
}
